export var BusinessRole;
(function (BusinessRole) {
    BusinessRole["Owner"] = "owner";
    BusinessRole["Admin"] = "admin";
    BusinessRole["Member"] = "member";
    BusinessRole["Viewer"] = "viewer";
})(BusinessRole || (BusinessRole = {}));
//# sourceMappingURL=business-role.const.js.map